import React from 'react';
import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';

export default function DateLargeCell({ value }) {
    if (value) {
        return (
            <FormattedDate
                value={value}
                year="numeric"
                month="long"
                day="2-digit" />
        );
    }
    return '';
}

DateLargeCell.propTypes = {
    value: PropTypes.object.isRequired,
};
